<template>
  <v-dialog v-model="dialogVisible" persistent max-width="820px">
    <v-card class="pa-4">
      <div class="d-flex justify-space-between">
        <p class="text-h6 ma-0 font-weight-bold text-uppercase">
          Edição de Usuário
          <v-progress-circular v-if="loadingCurrentUser" class="ml-2 mb-1" color="black" size="20" height="7"
            indeterminate></v-progress-circular>
        </p>

        <v-icon color="black darken-1" @click="closeDialog">mdi mdi-close</v-icon>
      </div>

      <v-divider class="mb-4"></v-divider>

      <v-row>
        <v-col class="pb-0" cols="6">
          <v-text-field :rules="textRules" hide-details class="my-2" label="Nome *" v-model="formUser.name" outlined
            dense placeholder="Nome"></v-text-field>

          <v-text-field hide-details class="my-2" label="Cargo (Opcional)" v-model="formUser.job" outlined dense
            placeholder="Executivo de vendas"></v-text-field>
        </v-col>

        <v-col class="pb-0" cols="6">
          <v-text-field :rules="textRules" :error-messages="emailErrors" hide-details class="mt-2" label="E-mail *"
            v-model="formUser.email" @input="handleEmailInput" outlined dense placeholder="E-mail" disabled>
            <template v-slot:append>
              <v-progress-circular v-if="loadingEmail" class="ml-2" color="primary" size="20" height="7"
                indeterminate></v-progress-circular>

              <v-icon color="red" v-if="emailErrors && emailErrors.length > 0">
                mdi-close
              </v-icon>

              <v-icon color="success" v-if="
                !emailErrors || (emailErrors.length === 0 && isEmailAvailable)
              ">
                mdi-check
              </v-icon>
            </template>
          </v-text-field>

          <v-select :rules="textRules" hide-details class="my-2" label="Setor *" :items="accessTypeIdItems"
            placeholder="Setor" v-model="formUser.accessTypeId" outlined item-value="id" item-text="name" dense
            :menu-props="{ width: '20px' }" :disabled="!isProfile"></v-select>
        </v-col>
      </v-row>

      <v-text-field :rules="textRules" hide-details class="my-2" label="Vínculo de atendimento *"
        v-model="formUser.info" outlined dense placeholder="Executivo para o setor financeiro"></v-text-field>

      <p class="text-h6 ma-0 mt-5 font-weight-bold text-uppercase">Contatos</p>

      <v-divider class="mb-4"></v-divider>

      <v-row class="align-center" v-for="(phone, index) in formUser.phones" :key="index">
        <v-col class="py-0" cols="3">
          <v-select :rules="textRules" :items="phoneTypes" item-value="id" item-text="name" placeholder="Celular *"
            v-model="phone.type" outlined dense :menu-props="{ width: '20px' }" hide-details
            :disabled="phone.disabled"></v-select>
        </v-col>

        <v-col class="py-0" cols="3">
          <v-select :rules="textRules" :items="['+55']" placeholder="+55 *" v-model="phone.ddi" outlined dense
            :menu-props="{ width: '20px' }" hide-details :disabled="phone.disabled"></v-select>
        </v-col>

        <v-col class="py-0" cols="4">
          <v-text-field :rules="textRules" hide-details class="my-2" label="Telefone *" v-model="phone.number"
            v-mask="['(##) ####-####', '(##) #####-####']" outlined dense placeholder="Telefone"
            :disabled="phone.disabled"></v-text-field>
        </v-col>

        <v-col v-if="phone.disabled" class="py-0 mb-2" cols="1">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="toggleDisabled(phone)" color="green">mdi-pencil</v-icon>
            </template>

            <span>Editar contato</span>
          </v-tooltip>
        </v-col>

        <v-col v-if="phone.contactId === undefined" class="py-0 mb-2" cols="1">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon @click="submitEditContact(phone)" color="green" v-bind="attrs" v-on="on">mdi-check-bold</v-icon>
            </template>

            <span>Criar contato</span>
          </v-tooltip>
        </v-col>

        <v-col v-if="phone.disabled || !phone.contactId" class="py-0 mb-2" cols="1">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon @click="deleteContact(phone, index)" v-bind="attrs" v-on="on" color="red">mdi-trash-can</v-icon>
            </template>

            <span>Remover contato</span>
          </v-tooltip>
        </v-col>

        <v-col v-if="!phone.disabled && phone.contactId" class="py-0 mb-2" cols="1">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon @click="toggleDisabled(phone)" v-bind="attrs" v-on="on" color="red">mdi-arrow-left-circle</v-icon>
            </template>

            <span>Cancelar edição</span>
          </v-tooltip>
        </v-col>

        <v-col v-if="!phone.disabled && phone.contactId != undefined" class="py-0 mb-2" cols="1">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon @click="submitEditContact(phone)" v-bind="attrs" v-on="on" color="green">mdi-check-bold</v-icon>
            </template>

            <span>Atualizar contato</span>
          </v-tooltip>
        </v-col>
      </v-row>

      <div class="d-flex align-center">
        <v-btn text color="primary" class="my-2" @click="addPhone">
          + Adicionar Telefone
        </v-btn>

        <v-progress-circular v-if="loadingEditContact" class="ml-2" color="primary" size="20" height="7"
          indeterminate></v-progress-circular>
      </div>

      <div class="d-flex justify-end">
        <v-btn @click="submitEditUser" color="green" style="color: white" :disabled="!isPhoneEdited">Salvar

          <v-progress-circular v-if="loadingAssocUser" class="ml-2" color="white" size="20" height="7"
            indeterminate></v-progress-circular>
        </v-btn>
      </div>
    </v-card>

    <v-snackbar v-model="showSnackbarSuccess" :timeout="2000" color="success" top>
      {{ messageSuccessSnackbar }}
    </v-snackbar>

    <v-snackbar v-model="showSnackbarError" :timeout="2000" color="red" top>
      {{ messageErrorSnackbar }}
    </v-snackbar>
  </v-dialog>
</template>

<script>
import debounce from "lodash/debounce";
import { getAuthToken } from '@/services/authService'

export default {
  name: "EditUserDialog",

  props: ["isEditUser", "currentUser"],

  computed: {
    dialogVisible: {
      get() {
        return this.isEditUser;
      },
      set(value) {
        this.$emit("update:isEditUser", value);
      }
    },

    emailErrors() {
      const errors = [];

      if (this.isEmailAvailable === false) {
        errors.push("E-mail já cadastrado");
      }

      return errors;
    },

    isProfile() {
      const currentUrl = window.location.href;

      return currentUrl.includes("publishers-details");
    },

    isPhoneEdited() {
      if (this.formUser.phones.length != 0) {
        const arrayStatusPhonesDisabled = this.formUser.phones.map((phone) => {
          if (phone.disabled === true) {
            return false;
          } else {
            return true;
          }
        });

        const currentStatusPhoneDisabled = arrayStatusPhonesDisabled.every(
          (disabled) => disabled === false
        );

        return currentStatusPhoneDisabled;
      } else {
        return true;
      }
    },

    profileId() {
      const currentPath = this.$route.path;
      const matchToGetProfileId = currentPath.match(/\/publishers-details\/(\d+)$/);

      return matchToGetProfileId ? matchToGetProfileId[1] : null;
    }
  },

  watch: {
    isEditUser(newVal) {
      if (newVal) {
        this.bindUserInfo();
      }
    },
  },

  data: () => ({
    textRules: [(v) => !!v || "Campo Obrigatório"],
    showSnackbarSuccess: false,
    messageSuccessSnackbar: "",
    showSnackbarError: false,
    messageErrorSnackbar: "",
    loadingEditContact: false,
    loadingAssocUser: false,
    loadingCurrentUser: false,
    loadingEmail: false,
    isEmailAvailable: null,

    formUser: {
      name: "",
      email: "",
      phones: [{ type: "", ddi: "", number: "", disabled: false }],
      job: "",
      info: "",
      accessTypeId: null,
      allData: null,
    },

    phoneTypes: [
      {
        id: 8,
        name: "Celular",
      },
      {
        id: 2,
        name: "Telefone Fixo",
      },
      {
        id: 9,
        name: "Whatsapp",
      },
    ],

    accessTypeIdItems: [
      {
        id: 1,
        name: "Admin",
      },
      {
        id: 3,
        name: "Comercial",
      },
      {
        id: 4,
        name: "Marketing",
      },
      {
        id: 5,
        name: "Financeiro",
      },
      {
        id: 9,
        name: "Criativo",
      },
      {
        id: 10,
        name: "OPEC",
      },
    ],
  }),

  methods: {
    bindUserInfo(isContactUpdate = false) {
      const authToken = getAuthToken()

      if (!isContactUpdate) {
        this.loadingCurrentUser = true;
        this.cleanForm();
        this.$axios
          .get(`profiles/admin/assoc/user/${this.currentUser.userId}?model=1`)
          .then((data) => {
            const currentUser = data.data.data[0];

            this.formUser.allData = currentUser;

            this.formUser.name = currentUser.userName;
            this.formUser.email = currentUser.userEmail;
            this.formUser.job = currentUser.userJob;
            this.formUser.info = currentUser.userInfo;
            this.formUser.accessTypeId = parseInt(currentUser.typeId);

            let phonesFormatted = [];

            currentUser.contacts.map((contact) => {
              if (contact.contactTypeId != 1) {
                phonesFormatted.push({
                  type: contact.contactTypeId,
                  ddi: "+55",
                  number: contact.contact.toString().substring(3),
                  contactId: contact.id,
                  disabled: true,
                });
              }
            });

            this.formUser.phones = phonesFormatted;
          })
          .finally(() => {
            this.loadingCurrentUser = false;
          });
      } else {
        this.loadingEditContact = true;

        this.$axios
          .get(`profiles/admin/assoc/user/${this.currentUser.userId}?model=1`)
          .then((data) => {
            const currentUser = data.data.data[0];

            let phonesFormatted = [];

            currentUser.contacts.map((contact) => {
              if (contact.contactTypeId != 1) {
                phonesFormatted.push({
                  type: contact.contactTypeId,
                  ddi: "+55",
                  number: contact.contact.toString().substring(3),
                  contactId: contact.id,
                  disabled: true,
                });
              }
            });

            this.formUser.phones = phonesFormatted;

            this.messageSuccessSnackbar = "Contato criado!";
            this.showSnackbarSuccess = true;
          })
          .finally(() => {
            this.loadingEditContact = false;
          });
      }
    },

    cleanForm() {
      this.formUser = {
        name: "",
        email: "",
        phones: [{ type: "", ddi: "", number: "", disabled: false }],
        job: "",
        info: "",
        accessTypeId: null,
        allData: null,
      };
    },

    toggleDisabled(phone) {
      phone.disabled = !phone.disabled;

      if (!phone.disabled) {
        phone.clonePhone = { ...phone };
      } else {
        if (phone.clonePhone) {
          Object.assign(phone, phone.clonePhone);
          phone.disabled = !phone.disabled;
          delete phone.clonePhone;
        }
      }
    },

    closeDialog() {
      this.cleanForm();
      this.$emit("update:isEditUser", false);
    },

    handleEmailInput(event) {
      this.debouncedCheckEmail();
    },

    addPhone() {
      this.formUser.phones.push({ type: "", number: "" });
    },

    async submitEditUser() {
      this.loadingAssocUser = true;
      let formattedFormData = {
        id: this.currentUser.userId,
        name: this.formUser.name,
        jobDescription: this.formUser.job,
        info: this.formUser.info,
        mv: true
      };

      if (this.profileId) {
        formattedFormData = {
          ...formattedFormData,
          profileId: this.profileId,
          accessTypeId: parseInt(this.formUser.accessTypeId),
        }
      }

      this.$axios.put(`publisherportal/admin`, formattedFormData)
        .then(() => {
          this.messageSuccessSnackbar = "Usuário editado!";
          this.showSnackbarSuccess = true;

          setTimeout(() => {
            this.closeDialog();
          }, 2000);
        })
        .finally(() => {
          this.loadingAssocUser = false;
        });
    },

    debouncedCheckEmail: debounce(function () {
      this.checkEmail();
    }, 500),

    async checkEmail() {
      try {
        this.loadingEmail = true;
        this.isEmailAvailable = null;
        this.isEmailValid = null;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!emailRegex.test(this.formUser.email)) {
          this.loadingEmail = false;
          this.isEmailValid = false;
          return;
        }

        return await this.$axios
          .post("assets/checker/email", {
            input: "email",
            value: this.formUser.email
          })
          .then((data) => {
            const statusEmail = data.data.data.available;

            this.loadingEmail = false;

            this.isEmailAvailable = statusEmail;
          });
      } catch (error) {
        console.log(error);
      }
    },

    async submitEditContact(contact) {
      this.loadingEditContact = true;

      if (contact.contactId != undefined) {
        const contactForm = {
          contactTypeId: contact.type,
          ddd: "+55",
          contact: "+55 " + contact.number,
        };

        await this.$axios
          .put(`contacts/${contact.contactId}`, contactForm)
          .then(() => {
            this.messageSuccessSnackbar = "Contato editado!";
            this.showSnackbarSuccess = true;
            contact.disabled = true;
          })
          .finally(() => {
            this.loadingEditContact = false;
          });
      } else {
        const contactForm = {
          name: this.formUser.name,
          userId: parseInt(this.formUser.allData.userId),
          contactTypeId: contact.type,
          ddd: "+55",
          contact: "+55 " + contact.number,
        };

        if (!contact.type || !contact.number || !contact.ddi) {
          this.showSnackbarError = true;
          this.loadingEditContact = false
          this.messageErrorSnackbar = "Preencha todos os campos do contato!";
        } else {
          await this.$axios
            .post(`contacts`, contactForm)
            .then(() => {
              this.bindUserInfo(true);
            })
            .catch(() => {
              this.loadingEditContact = false;
            });
        }
      }
    },

    async deleteContact(contact, index) {
      if (contact.contactId != undefined) {
        this.loadingEditContact = true;
        await this.$axios
          .delete(`contacts/${contact.contactId}`)
          .then(() => {
            this.messageSuccessSnackbar = "Contato excluído!";
            this.showSnackbarSuccess = true;

            this.formUser.phones.splice(index, 1);
          })
          .finally(() => {
            this.loadingEditContact = false;
          });
      } else {
        this.formUser.phones.splice(index, 1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  font-family: 'Roboto', sans-serif !important;
}
</style>